import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import SuitesReceiptDetails from '../../components/receipt/SuitesReceiptDetails'

import { getReceiptDetails } from '../../actions/receipt'
import { makeGetOrder } from '../../selectors/order'
import { makeGetDigitalReceipt } from '../../selectors/digitalReceipt'
import { getIsSuitesMode } from '../../selectors/config'

const mapStateToProps = (state, ownProps) => {
  const orderUuid = ownProps?.match?.params?.orderUuid ?? state?.order?.currentOrderId
  const paymentId = ownProps?.match?.params?.paymentId ?? ''

  const getOrder = makeGetOrder()
  const getDigitalReceipt = makeGetDigitalReceipt()

  const order = getOrder(state, orderUuid)
  const digitalReceipt = getDigitalReceipt(state, orderUuid, paymentId)
  const isSuites = getIsSuitesMode(state)

  return {
    orderNumber: order.orderNumber,
    digitalReceipt,
    isSuites,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const orderUuid = ownProps?.match?.params?.orderUuid ?? ''
  const historyState = ownProps?.history?.location?.state
  const fromSignature = historyState?.fromSignature

  return {
    onMount: () => {
      dispatch(getReceiptDetails({ orderId: orderUuid }))
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SuitesReceiptDetails))
